<style lang="scss" scoped>
.link-field {
    position: relative;
    input {
        border-width: 0;
        border-radius: 4px;
        background-color: #f8f8f8 !important;
        height: 44px;
        color: #172340;
        font-size: 1.25rem;
        padding-left: 16px;
        padding-right: 120px;
        font-weight: 200;
        text-overflow: ellipsis;
    }

    .copy {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);

        a {
            color: var(--accent);
            font-size: 1.25rem;
            text-decoration: underline;
            font-weight: 200;
        }

        .tooltip {
            padding: 10px 16px;
            font-size: 1.25rem;
            font-weight: 300;
            line-height: 2.125rem;
            margin-right: 0;
            width: 180px;
        }
    }
}

.privacy {
    label {
        cursor: pointer;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
    }
}

.export {
    color: #172340;
    font-size: 1.25rem;
    font-weight: 400;
    transition: color 0.15s;

    span {
        display: inline-block;
        margin-left: 16px;

        ::v-deep svg {
            width: 20px;
            height: 20px;
            transform: translateY(-2px);

            path {
                transition: fill 0.15s;
            }
        }
    }

    &:hover {
        color: var(--accent);

        span {
            ::v-deep svg {
                path {
                    fill: var(--accent);
                }
            }
        }
    }
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <h2 class="mb-32">{{ translations.save_popup.title }}</h2>
        <p class="mb-40">{{ translations.save_popup.description }}</p>

        <div class="link-field d-flex justify-content-between align-items-center  mb-40">
            <input type="text" v-model="privateUrl">

            <div class="copy ml-32">
                <a v-clipboard:copy="privateUrl" v-clipboard:success="onCopy">{{ translations.save_popup.copy }}</a>
                <span class="tooltip tooltip-top" :class="{'visible': copied}">{{ translations.save_popup.copied }}</span>
            </div>
        </div>

        <hr class="mb-40">

        <ValidationObserver v-slot="{ invalid }" tag="div" :slim="true" ref="observer">
            <template v-if="!success">
                <div class="row">
                    <el-input v-model="email" class="col-12 mb-24" type="email" :label="translations.save_popup.email" rules="required|email" />
                </div>

                <ValidationProvider ref="provider" vid="privacy_policy" :name="translations.save_popup.privacy_policy" :rules="'required'" :bails="false" v-slot="{ classes, errors }">
                    <div class="privacy d-flex align-items-center" @click="privacyPolicy = !privacyPolicy">
                        <el-checkbox :value="privacyPolicy"></el-checkbox>
                        <label class="ml-12 mb-0 font-weight-light" :for="translations.save_popup.privacy_policy" v-html="privacyPolicyLinkText"></label>
                    </div>

                    <label v-if="errors[0]" class="text-status-error small">{{ errors[0] }}</label>
                </ValidationProvider>
            </template>
            <template v-else>
                <p>{{ translations.save_popup.save_mail_success }}</p>
            </template>

            <div class="d-flex mt-40 justify-content-between align-items-center">
                <button type="submit" class="btn btn-accent text-white" :disabled="(invalid || !acceptedPrivacyPolicy) || success" @click.stop="submit">{{ translations.save_popup.send }}</button>
                <a v-if="localSchedule.activities.length > 0" :href="route('schedule-pdf', [localSchedule.id])" class="export">{{ translations.save_popup.export_pdf }}<span v-html="svg('export', 'icon')"></span></a>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import hasForm from '../../mixins/has-form'
import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from 'vee-validate/dist/locale/nl.json';
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

export default {
    components: { ValidationObserver, ValidationProvider },

    mixins: [core, safariFixedBottom, hasForm],

    props: {
        localSchedule: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        privateUrl: '',
        email: '',
        privacyPolicy: false,
        copied: false
    }),

    mounted() {
        this.privateUrl = route('nl.day-configurator', [this.localSchedule.id])
    },

    methods: {
        submit() {
            this.beforeSubmit()
            let data = {
                email: this.email,
                privateUrl: this.privateUrl
            }
            axios.post('/api/schedules/save', data)
                .then(response => {
                    this.handleSuccess()
                })
                .catch(e => this.handleError(e));
        },

        onCopy() {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 3000);
        }
    },

    computed: {
        acceptedPrivacyPolicy() {
            return this.privacyPolicy === true
        },

        privacyPolicyLinkText: function () {
            let output = this.translations.save_popup.privacy_policy;
            let privacyPolicyLink = route('nl.legal', ['privacy-policy']);

            if ((output.match(/%s/g) || []).length == 2) { //only replace if 2 hashtags are present in the string
                let i = 0;
                let anchorReplacements = [`<a class=\"text-accent\" target=\"_blank\" href=\"${privacyPolicyLink}\">`, "</a>"]
                output = output.replace(/%s/g, function (matched) {
                    let replacement = anchorReplacements[i];
                    i++;
                    return replacement;
                });
            }

            return output;
        },
    }
}
</script>